module.exports = __webpack_public_path__ + "static/img/bg1.3337454f.png";